<template>
  <div id="app" class="d-flex flex-column">
    <!-- Skip link per navigazione tastiera (WCAG 2.4.1) -->
    <a
      href="#main-content"
      class="sr-only sr-only-focusable skip-link"
    >
      {{ $t('AccessibilityToolbar.skipToContent') }}
    </a>

    <!-- Avviso globale (store alert): un foglio flottante in alto a destra
         (pattern .app-toast di _alerts.scss), sopra a tutto -->
    <b-alert
      :variant="alert.type"
      dismissible
      fade
      :show="alert.message !== null"
      @dismissed="clearAlert"
      @dismiss-count-down="clearAlert"
      class="app-toast"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {{ alert.message }}
    </b-alert>
    <!-- MAIN -->
    <!-- <b-container fluid class="p-0 custom__content__df main__operatore"> -->
    <main id="main-content" tabindex="-1">
      <b-container fluid class="p-0 custom__content__df">
      <b-row cols="1">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </b-row>
    </b-container>
    </main>

    <!-- <b-row v-if="!user">
      <CallMailSupportButtons></CallMailSupportButtons>
    </b-row> -->

    <!-- footer -->
    <!-- <b-button @click="setCssPuntofarma">CAMBIA TEMA COLORE</b-button> -->
    <footer class="py-0 px-0 mt-auto pb-1" role="contentinfo">
      <div class="px-0 text-center fs-6 bg-mdm-light-grey shadow_1">
        <!-- :class="showScrollBtn ? 'col-lg-9' : 'col-lg-12'" -->
        <span class="mx-1 line__h">
          Copyright © - Qwince s.r.l. - Via Principe di Belmonte, 102 - 90139
          Palermo - {{$t('app.partita_iva')}} 11801100964
        </span>
        <span>- </span>
        <template v-if="user && user.type === 1">
          <a :href="termsConditionLinks.operatore" target="_blank" rel="noopener noreferrer"
            >{{ $t('app.termini_condizioni') }}
          </a>
          <span class="mx-0 px-0"> - </span>
          <a
            :href="privacyPolicyLinks.operatore"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-0 px-0"
          >
            {{ $t('app.informativa_privacy') }}
          </a>
        </template>
        <template v-else>
          <a :href="termsConditionLinks.paziente" target="_blank" rel="noopener noreferrer"
            >{{ $t('app.termini_condizioni') }}
          </a>
          <span class="mx-0 px-0"> - </span>
          <a
            :href="privacyPolicyLinks.paziente"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-0 px-0"
          >
            {{ $t('app.informativa_privacy') }}
          </a>
        </template>
        <span class="mx-0 px-0"> - </span>
        <a :href="`/${$root.scope}/assets/docs/cookie-policy.pdf`" target="_blank" rel="noopener noreferrer">
          {{ $t('app.cookie_policy') }}
        </a>
        <span class="mx-0 px-0"> - </span>
        <button
          type="button"
          class="btn btn-link p-0 align-baseline point"
          @click="$bvModal.show('about-modal')"
          :aria-label="$t('app.about_label')"
        >
          {{ $t('app.about') }}
        </button>
        <span class="mx-0 px-0"> - </span>
        <ChangeLogComponent />
      </div>
    </footer>
    <!-- Toolbar accessibilità sempre visibile -->
    <AccessibilityToolbar :class="a11yToolbarClass" />
    <b-modal
      id="about-modal"
      centered
      hide-footer
      content-class="about-modal-content"
      header-class="pb-0 pt-2"
      body-class="pt-1"
      :aria-label="$t('app.about_modal_label')"
    >
      <template #default>
        <div class="about-image-container">
          <button
            type="button"
            class="btn p-0 border-0 bg-transparent"
            @click="
              $bvModal.hide('about-modal');
              $router.push({ name: 'help' });
            "
            :aria-label="$t('app.vai_alla_guida')"
          >
            <img
              class="about-modal-image"
              :src="require(`@/assets/${$root.scope}/etichetta.png`)"
              :alt="$t('app.about_image_alt')"
            />
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";
import ChangeLogComponent from "@/app/layout/components/ChangeLogComponent.vue";
import AccessibilityToolbar from "@/app/common/components/AccessibilityToolbar.vue";

export default {
  components: {
    ChangeLogComponent,
    AccessibilityToolbar,
  },
  data() {
    return {
      showScrollBtn: false,
      themeCustomOption: false,
      currentPfVersion: process.env.VUE_APP_PF_VERSION,
      termsConditionLinks: {
        paziente: process.env.VUE_APP_LINK_TC_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_TC_OPERATORE,
      },
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE,
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
    isRegisterRoute() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      return path.startsWith("/register");
    },
    a11yToolbarClass() {
      return this.isRegisterRoute
        ? "a11y-toolbar-fixed a11y-toolbar-fixed--left"
        : "a11y-toolbar-fixed";
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
    }),
    ...mapActions("utente", ["me"]),
    ...mapActions("company", ["logUserCompanyIn"]),
    // ...mapActions("settings", ["setActiveServices"]),
    scrollUp() {
      window.scrollTo(0, 0);
    },
    showScrollUp() {
      var bottom = document.querySelector("#page__bottom");
      if (!bottom) {
        return false;
      }
      var bounding = bottom.getBoundingClientRect();
      if (
        bounding.bottom >
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        return true;
      }
      return false;
    },
    setCss() {
      //  var  ref=  `url(${require("@/assets/compiled/app.custom.css")})`
      var theme = this.themeCustomOption ? "custom" : "puntofarma";
      this.themeCustomOption = !this.themeCustomOption;
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.id = "customstyle";
      link.type = "text/css";
      // link.href = `url(${require("@/assets/compiled/app.custom.css")})`;
      link.href = "/compiled/app." + theme + ".css";
      document.head.appendChild(link);
      // console.log(document.head);
    },
    setCssPuntofarma() {
      var scriptel = document.getElementById("customstyle");
      try {
        scriptel.remove();
      } catch (err) {
        // console.log(err)
        return;
      }
      this.setCss();
    },
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
      this.showScrollBtn = this.showScrollUp();
      // console.log(to);
    },
  },
  created() {
    if (this.user) {
      this.me();
      if (this.user.type === 1) {
        this.logUserCompanyIn();
      }
    }
    const mainPages = [
      "/cittadino/home",
      "/operatore/home",
      "/admin/home",
      "/impostazioni",
      "/profilo",
      "/orari",
    ];
    // console.log(this.$route);
    if (!mainPages.includes(this.$route.path)) {
      this.$root.menuLeft = true;
    }
  },
  mounted() {
    // this.setActiveServices();
  },
  updated() {
    // console.log("APP HAS UPDATED", this.$root.isMobile);
    this.showScrollBtn = this.showScrollUp();
  },
};
</script>

<style lang="scss" scoped>
#logo-column {
  width: 120px;
  background-color: blue;
}

#card-wrapper {
  border: 0.5px solid rgb(209, 209, 209);
  border-radius: 10px;
}

#qr-code-row {
  width: 120px;
  background-color: red;
}

.indxz {
  z-index: 30;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}

#page__bottom {
  background-color: darkgray;
  min-height: 100%;
}

#lower-iso-card {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 550;
  z-index: 100;
  position: relative;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  margin-top: -5px;
}

.custom__content__df {
  min-height: 70vh;
}

.line__h {
  line-height: 2.5;
}

.fixed__alert {
  position: fixed !important;
  z-index: 9999999 !important;
}

#version-data-block {
  font-size: 13px;
}

#etichetta-top-section {
  display: flex;
  border-bottom: 0.5px solid rgb(209, 209, 209);
}

.about-modal-content {
  padding: 0;
}

.about-image-container {
  max-width: 466px;
  max-height: 366px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.about-modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Skip link: visibile solo al focus (WCAG 2.4.1) */
.skip-link:focus {
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 9999999;
  padding: 1rem 1.5rem;
  background-color: $black;
  color: #ffd04d;
  font-weight: 700;
  text-decoration: none;
  clip: auto !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
}

/* Toolbar accessibilità fissa in basso a destra, a sx dei bottoni supporto */
.a11y-toolbar-fixed {
  position: fixed;
  bottom: 70px;
  right: 230px;
  z-index: 1000;
}

.a11y-toolbar-fixed--left {
  right: auto;
  left: 20px;
  bottom: 20px;
}

@media (max-width: 991px) {
  .a11y-toolbar-fixed {
    right: 20px;
    bottom: 20px;
  }
  .a11y-toolbar-fixed--left {
    right: auto;
    left: 20px;
  }
}
</style>
